import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import { scrollIntoView } from "seamless-scroll-polyfill";
import useMediaQuery from '@mui/material/useMediaQuery';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import Favorite from '@mui/icons-material/Favorite';
import CelebrationIcon from '@mui/icons-material/Celebration';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CakeIcon from '@mui/icons-material/Cake';
import Alert from '@mui/material/Alert';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import { useEffect } from 'react';

import './app.css'


import axios from 'axios'

import logo from './images/logo.png'
import fpc from './images/fpc.png'
import fpcWhite from './images/fpc-white.png'
import fpcNoText from './images/fpc-notext.png'
import weddings from './images/weddings.png'
import funerals from './images/funerals.png'
import namingCeremonies from './images/namingceremonies.png'
import scripts from './images/scripts2.png'
import socialsInstagram from './images/Instagram_Glyph_Gradient_RGB.png'
import socialsFacebook from './images/f_logo_RGB-Blue_144.png'
import socialsFacebookWhite from './images/f_logo_RGB-White_250.png'
import socialsInstagramWhite from './images/Instagram_Glyph_White.png'
import emma from './images/emma.png'

const themeContent = {
  "components": {
    "MuiPaper": {
      "variants": [
        {
          "props": { "type": "summary" },
          "style": {
            "borderTop": "5px solid #19bec8",
            "padding": 15,
            "marginTop": 10,
            "textAlign": "center"
          }
        }
      ]
    },
    "MuiAppBar": {
      "styleOverrides": {
        "root": {
          "backgroundColor": 'rgba(255, 255, 255, 0.8)'
        }
      }
    },
  },
  "palette": {
    "primary": {
      "main": "#253e29",
      "contrastText": "#000000"
    },
    "secondary": {
      "main": "#b2cdc1",
      "contrastText": "#ffffff"
    },

    "info": {
      "main": "#000000",
      "contrastText": "#ffffff"
    }
  }
}

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const theme = createTheme(themeContent);

const pages = ['Home', 'About Emma', 'Weddings', 'Naming Ceremonies', 'Script Writing', 'Funerals', 'Contact'];

function App() {

  const isSmall = useMediaQuery('(max-width:899px)');

  const [emailSentSuccessfully, setEmailSentSuccessfully] = React.useState(null);

  const submit = function (e) {

    e.preventDefault();
    setEmailSentSuccessfully(true)

    const message = `Enquiry received from ebcelebrancy.com
  
  Name: ${e.target.name.value}
  Contact Number: ${e.target.contactnumber.value}
  Email: ${e.target.email.value}
  
  Message : 
  ${e.target.message.value}
  
  End of message.
  `

    const data = {
      "email": e.target.email.value,
      "_subject": `ebcelebrancy.com - Enquiry from ${e.target.name.value}`,
      "message": message
    }

    axios.post(`https://formsubmit.co/ajax/emma@ebcelebrancy.com`, data)
      .then(response => {
        if (response.status === 200) {
          setEmailSentSuccessfully(true)
        }
      })
      .catch(error => {
        setEmailSentSuccessfully(false)
      })
  }

  const [drawer, setDrawer] = React.useState(false);

  const toggleDrawer = (state) => (event) => {
    setDrawer(state);
  };


  //   <Box
  //   sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
  //   role="presentation"
  //   onClick={toggleDrawer(anchor, false)}
  //   onKeyDown={toggleDrawer(anchor, false)}

  // >

  const list = () => (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
      <List sx={{ fontFamily: 'Garamond' }}>
        <ListItem sx={{ fontFamily: 'Garamond' }} key={'home'} disablePadding>
          <ListItemButton onClick={(e) => { goToSection('home', e) }}>
            <ListItemIcon>
              <HomeIcon sx={{ color: '#b2cdc1' }} />
            </ListItemIcon>
            <ListItemText sx={{ fontFamily: 'Garamond' }} primary={'Home'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={'aboutemma'} disablePadding>
          <ListItemButton onClick={(e) => { goToSection('aboutemma', e) }}>
            <ListItemIcon>
              <InfoIcon sx={{ color: '#b2cdc1' }} />
            </ListItemIcon>
            <ListItemText primary={'About Emma'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={'weddings'} disablePadding>
          <ListItemButton onClick={(e) => { goToSection('weddings', e) }}>
            <ListItemIcon>
              <Favorite sx={{ color: '#b2cdc1' }} />
            </ListItemIcon>
            <ListItemText primary={'Weddings'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={'namingceremonies'} disablePadding>
          <ListItemButton onClick={(e) => { goToSection('namingceremonies', e) }}>
            <ListItemIcon>
              {/* <CelebrationIcon sx={{ color: '#b2cdc1' }} /> */}
              <CakeIcon sx={{ color: '#b2cdc1' }} />
            </ListItemIcon>
            <ListItemText primary={'Naming Ceremonies'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={'scriptwriting'} disablePadding>
          <ListItemButton onClick={(e) => { goToSection('scriptwriting', e) }}>
            <ListItemIcon>
              <MenuBookIcon sx={{ color: '#b2cdc1' }} />
            </ListItemIcon>
            <ListItemText primary={'Script Writing'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={'funerals'} disablePadding>
          <ListItemButton onClick={(e) => { goToSection('funerals', e) }}>
            <ListItemIcon>
              <LocalFloristIcon sx={{ color: '#b2cdc1' }} />
            </ListItemIcon>
            <ListItemText primary={'Funerals'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={'contact'} disablePadding>
          <ListItemButton onClick={(e) => { goToSection('contact', e) }}>
            <ListItemIcon>
              <MailIcon sx={{ color: '#b2cdc1' }} />
            </ListItemIcon>
            <ListItemText primary={'Contact'} />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <img style={{ opacity: '0.5', width: '50vw', marginLeft: 'auto', marginRight: 'auto', display: 'block', marginTop: '50px' }} src={logo} alt="Logo" />
    </Box>
  );

  const anchor = (anchor) => {

    if (isSmall) {
      return (
        <Box sx={{ position: 'relative', top: '120px', left: 0, display: { xs: 'block', sm: 'block', md: 'none' } }}><Box id={anchor}></Box></Box>
      )
    } else {
      return (
        <Box sx={{ position: 'relative', top: '-70px', left: 0, display: { xs: 'none', md: 'flex' } }}><Box id={anchor}></Box></Box>
      )
    }
  }

  const email = (anchor) => {

    if (emailSentSuccessfully === true) {
      return (
        <Alert severity="success">Email sent successfully - I'll be in contact shortly.</Alert>
      )
    } else if (emailSentSuccessfully === false) {
      return (
        <Alert severity="error">Something went wrong, please try sending again.</Alert>
      )
    }
  }

  const goToSection = (event) => {

    toggleDrawer(false);

    //ensure section matches id
    const sectionName = event.replace(/\s+/g, '').toLowerCase()

    let section = document.getElementById(sectionName);
    section && scrollIntoView(section, { behavior: "smooth", block: "start", inline: "nearest" });

  };

  function srcset(image, size, rows = 1, cols = 1) {
    return {
      src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
      srcSet: `${image}?w=${size * cols}&h=${size * rows
        }&fit=crop&auto=format&dpr=2 2x`,
    };
  }

  const itemData = [
    {
      img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
      title: 'Breakfast',
      rows: 2,
      cols: 2,
    },
    {
      img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
      title: 'Burger',
    },
    {
      img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
      title: 'Camera',
    },
    {
      img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',
      title: 'Coffee',
      cols: 2,
    },
    {
      img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
      title: 'Hats',
      cols: 2,
    },
    {
      img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',
      title: 'Honey',
      author: '@arwinneil',
      rows: 2,
      cols: 2,
    },
    {
      img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',
      title: 'Basketball',
    },
    {
      img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',
      title: 'Fern',
    },
    {
      img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',
      title: 'Mushrooms',
      rows: 2,
      cols: 2,
    },
    {
      img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',
      title: 'Tomato basil',
    },
    {
      img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',
      title: 'Sea star',
    },
    {
      img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',
      title: 'Bike',
      cols: 2,
    },
  ];

  useEffect(() => {
    const script = document.createElement('script');

    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    script.defer = true;
    script.setAttribute("data-use-service-core", "");

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, []);

  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <Box sx={{ fontFamily: 'Garamond' }} id="home" />
        <Paper>

          <AppBar style={{ boxShadow: 'none' }} position="sticky">
            <Container maxWidth="lg">
              <Toolbar disableGutters>
                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                  <React.Fragment>
                    <Button onClick={toggleDrawer(true)}>
                      <MenuIcon />
                    </Button>
                    <Drawer anchor="left" open={drawer} onClose={toggleDrawer(false)}>
                      {list()}
                    </Drawer>
                  </React.Fragment>
                </Box>
                <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} />
                <Box sx={{ flexGrow: 0, display: { xs: 'none', md: 'flex' } }}>
                  {pages.map((section) => (
                    <Button variant="large" key={section} onClick={(e) => { goToSection(section, e) }} sx={{ my: 2, display: 'block', fontFamily: 'Garamond' }}>
                      {section}
                    </Button>
                  ))}
                </Box>
              </Toolbar>
            </Container>
          </AppBar>

          {/* Logo */}
          <Container sx={{ marginBottom: '50px' }} maxWidth="xl">
            <Grid container spacing={0} direction="column" alignItems="center">
              {/* Mobile */}
              <Grid sx={{ display: { xs: 'block', lg: 'none' } }} item xs={12}>
                <img style={{ width: '80vw' }} sx={{ width: '50vw', margin: 'auto', display: 'none' }} src={logo} alt="Logo" />
              </Grid>
              {/* Desktop */}
              <Grid sx={{ display: { xs: 'none', sm: 'none', lg: 'block' } }} item xs={12}>
                <img style={{ width: '90vh' }} sx={{ width: '50vw', margin: 'auto', display: 'none' }} src={logo} alt="Logo" />
              </Grid>
            </Grid>
          </Container>

          {/* About me */}
          <Box sx={{ backgroundColor: '#f7f8f7', fontFamily: 'Garamond' }}>
            {anchor('aboutemma')}
            <Container sx={{ marginTop: '0px' }} maxWidth="lg">
              <Box fullWidth sx={{ paddingTop: '1px' }} />
              <Typography sx={{ fontFamily: 'CochocibScriptLatinPro', marginTop: '30px', color: '#b2cdc1' }} variant={!isSmall ? "h1" : "h3"}>About Emma</Typography>
              <Grid container spacing={2} style={{ marginTop: '5px' }}>
                <Grid item xs={12} md={6} >
                  <Item elevation={0} sx={{ backgroundColor: '#f7f8f7', textAlign: 'left', fontFamily: 'Garamond' }}>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="inherit">
                      Hi I’m Emma and I am very lucky to call Cheltenham my home and have a wonderful life with my Husband, two Daughters and two cats. I could talk all day about Disney, Halloween or rollercoasters. Oh, and I love LOVE! I make any excuse for a celebration and that’s why I became a Celebrant!
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      From births to deaths and every rite of passage in-between, major milestones in life signify celebrating love in its many guises. It’s the honouring of life’s perfections and blemishes and love conquering all no matter what. I cannot wait to meet you and tell your story in your perfect ceremony.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      I became a celebrant back in 2022 after I lost my Dad and I knew from that moment that my life would never be the same again. A family friend, who is a Celebrant, led the service and she gave us the confidence to design a one-of-a-kind service totally befitting to my beloved Dad. We knew we didn’t want to have a copy and paste type funeral, as my Dad just wasn’t like that. We took his ashes and created a memorial service in his local pub! The day was full of celebration, tears, laughter and hope and an occasion I will never forget. For all the right reasons. The way our Celebrant made us feel on the day and her approach to our wishes encouraged us to give my Dad a wonderful send off and helped our grieving process tremendously.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      After the past few years in a global pandemic, I think we all reserve the right to celebrate the milestones in our lives and create special memories which will last a lifetime. So here I am, at your service and here to help you create your own one-of-a-kind wedding, naming ceremony, funeral or any ceremony / event you can think of.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      I have completed my training with the Fellowship of Professional Celebrants where I am also a member.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      For further information, feel free to visit my social pages or contact me for a chat!
                    </Typography>
                    <Box sx={{ marginTop: '50px', display: { xs: 'none', md: 'block' }, float: 'left' }}>
                      <Tooltip placement="bottom" title="Instagram profile">
                        <a rel="noreferrer" href="https://www.instagram.com/emmabutlercelebrant" target="_blank">
                          <IconButton color="primary" aria-label="upload picture" component="span">
                            <img align="left" width="50px" src={socialsInstagram} alt="My Instagram profile" />
                          </IconButton>
                        </a>
                      </Tooltip>
                    </Box>
                    <Box sx={{ marginTop: '50px', marginLeft: '12px', display: { xs: 'none', md: 'block' }, float: 'left' }}>
                      <Tooltip placement="bottom" title="Facebook profile">
                        <a rel="noreferrer" href="https://www.facebook.com/Emma-Butler-Independent-Celebrant-115173494526218" target="_blank">
                          <IconButton color="primary" aria-label="upload picture" component="span">
                            <img align="left" width="50px" src={socialsFacebook} alt="My Facebook profile" />
                          </IconButton>
                        </a>
                      </Tooltip>
                    </Box>
                    <Box sx={{ marginTop: '50px', marginLeft: '12px', display: { xs: 'none', md: 'block' }, float: 'left' }}>
                      <Tooltip placement="bottom" title="Fellowship of Professional Celebrants">
                        <a rel="noreferrer" href="https://professionalcelebrants.org.uk/" target="_blank">
                          <IconButton color="primary" aria-label="upload picture" component="span">
                            <img align="left" width="50px" src={fpcNoText} alt="Fellowship of Professional Celebrants" />
                          </IconButton>
                        </a>
                      </Tooltip>
                    </Box>
                  </Item>
                </Grid>
                <Grid item xs={12} md={6} >
                  <Item sx={{ backgroundColor: '#f7f8f7' }} elevation={0}>
                    {/* <div class="elfsight-app-3eed583e-2756-4a05-9ce6-3a564db76343"></div> */}
                    <img width="350px" src={emma} alt="Emma" />
                  </Item>
                </Grid>
              </Grid>
            </Container>
            <svg id="visual" viewBox="0 0 100% 200" width="100%" height="200" preserveAspectRatio="none" version="1.1"><rect x="0" y="0" width="100%" height="200" fill="#f7f8f7"></rect><path d="M0 97L71.5 96.2C143 95.3 286 93.7 428.8 96C571.7 98.3 714.3 104.7 857.2 104.5C1000 104.3 1143 97.7 1285.8 93.5C1428.7 89.3 1571.3 87.7 1714.2 91.8C1857 96 2000 106 2142.8 107.5C2285.7 109 2428.3 102 2571.2 93.8C2714 85.7 2857 76.3 2928.5 71.7L3000 67L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#f7f8f7"></path><path d="M0 97L71.5 101.7C143 106.3 286 115.7 428.8 117.8C571.7 120 714.3 115 857.2 116C1000 117 1143 124 1285.8 121.3C1428.7 118.7 1571.3 106.3 1714.2 104C1857 101.7 2000 109.3 2142.8 116.3C2285.7 123.3 2428.3 129.7 2571.2 126C2714 122.3 2857 108.7 2928.5 101.8L3000 95L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#f2f4f2"></path><path d="M0 120L71.5 125C143 130 286 140 428.8 140.2C571.7 140.3 714.3 130.7 857.2 126.3C1000 122 1143 123 1285.8 128.5C1428.7 134 1571.3 144 1714.2 147.5C1857 151 2000 148 2142.8 142.5C2285.7 137 2428.3 129 2571.2 125.5C2714 122 2857 123 2928.5 123.5L3000 124L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#eef0ee"></path><path d="M0 162L71.5 162C143 162 286 162 428.8 162C571.7 162 714.3 162 857.2 160.2C1000 158.3 1143 154.7 1285.8 153.5C1428.7 152.3 1571.3 153.7 1714.2 155C1857 156.3 2000 157.7 2142.8 158.8C2285.7 160 2428.3 161 2571.2 162.7C2714 164.3 2857 166.7 2928.5 167.8L3000 169L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#e9ece9"></path></svg>
          </Box>

          {/* Weddings */}
          <Box sx={{ marginTop: '-10px', backgroundColor: '#e9ece9' }}>
            {anchor('weddings')}
            <Container sx={{ marginTop: '0px' }} maxWidth="lg">
              <Box fullWidth sx={{ paddingTop: '1px' }} />
              <Typography sx={{ marginTop: '10px', color: '#b2cdc1', fontFamily: 'CochocibScriptLatinPro' }} variant={!isSmall ? "h1" : "h3"}>Weddings / Renewal of Vows</Typography>
              <Grid container spacing={2} direction="row" style={{ marginTop: '5px', }}>
                <Grid item xs={12} md={8} >
                  <Item elevation={0} sx={{ backgroundColor: '#e9ece9', textAlign: 'left', fontFamily: 'Garamond' }}>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      The beauty of a celebrant led wedding ceremony is the opportunity to build your wedding day exactly how you want it with no constraints of location, time, content and who you want to be involved!
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      More couples are choosing to keep their Religious or Civil Ceremonies where the legal registration of marriage takes place separate from their wedding day. Reasons could be that they have chosen to have their wedding day at a venue personal to them but does not hold a marriage license such as a family garden. The legal ceremony can take place at another time and we can then work together at creating a ceremony on your wedding day that is one of a kind.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      With me as your Celebrant you can respect tradition and embrace modern unions in creating new ways of celebrating your love for one another! You might like to combine traditional aspects of a wedding ceremony such as vows, ring exchanges, blessings, music and reading as well as symbolic elements such as handfasting, ring warming, jumping the broom. We can have a good chat about what is fitting to your day and create a ritual which is truly unique. Together we can create the wedding ceremony of your dreams, as individual as your love and reflecting your core values and how you want to spend the rest of your lives together.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      I love to get to know you both as a couple so that by the time the big day comes, I feel like we have known each other for years! My role on your big day is to ensure you are both the stars of your own love story and to design a ceremony so perfect for you that your congregation feel like they are watching a movie made about the greatest love story ever known...yours!
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      You may also be celebrating a milestone anniversary of being married and a renewal of vows or recommitment ceremony may be at the heart of honouring your wedding some time ago. Together we can take a trip down memory lane and create a ceremony which encompasses the couple you became on your wedding day and all major moments you have shared together ever since. My job is to tell your story so far and the unique bond you share.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      You may also be celebrating a milestone anniversary of being married and a renewal of vows or recommitment ceremony may be at the heart of honouring your wedding some time ago. Together we can take a trip down memory lane and create a ceremony which encompasses the couple you became on your wedding day and all major moments you have shared together ever since. My job is to tell your story so far and the unique bond you share.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Every couple is different but to give you an idea of how things will play out:
                      <ul>
                        <li>Initial meeting – we can schedule a video call where we can chat through your ideas.</li>
                        <li>Paperwork, contracts, terms and conditions, deposit, date confirmed, questionnaire so I can start writing the script </li>
                        <li>Face to face meeting to discuss vows, readings, music, and rituals anything you would like to incorporate in the ceremony. I can offer suggestions / advice if you would like any guidance.</li>
                        <li>I offer a vow writing session as an optional extra (together or separately...it depends on if you both would prefer a surprise on the big day!)</li>
                        <li>First reading with you to allow us the opportunity to edit the script.</li>
                        <li>Redraft and finalisation of script.</li>
                        <li>Rehearsal</li>
                        <li>Arrival at venue at least one hour beforehand, liaise with venue managers, wedding planners / coordinators photographers, anyone integral to your big day.</li>
                        <li>Presentation of commemorative signed certificate of your ceremony, keepsake copy of script and a little gift from me!</li>
                      </ul>
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Prices from £700, please do get in touch so that we can discuss your plans for your ceremony and make your wedding day the best day of your life! Price of celebrant fees will vary dependent on your requirements.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Please note: a £200 non-refundable deposit will be payable at the time of booking to secure the date in my calendar. The remainder of the fee is then in two staged payments.
                      Draft fee (£250): being due on notification that's the first draft of the ceremony has been completed and prior to receipt of said draft.
                      Balance of payment (£250): Being due 14 days prior to the ceremony. 
                    </Typography>
                    <Box fullWidth sx={{ paddingTop: '20px' }} />
                  </Item>
                </Grid>
                <Grid item xs={12} md={4} >
                  <Item sx={{ backgroundColor: '#e9ece9' }} elevation={0}>
                    <Typography sx={{ backgroundColor: '#e9ece9', marginTop: '100px', color: 'Gray' }} variant="body"><img width="300px" sx={{ backgroundColor: '#e9ece9', margin: 'auto', display: 'block' }} src={weddings} alt="Logo" /> </Typography>
                  </Item>
                </Grid>
              </Grid>
            </Container>
          </Box>
          <Box>
          </Box>

          {/* Naming Ceremonies */}
          <Box sx={{ backgroundColor: '#f7f8f7', fontFamily: 'Garamond', marginTop: '0px' }}>
            <svg id="visual" viewBox="0 0 100% 200" width="100%" height="200" preserveAspectRatio="none" version="1.1"><rect x="0" y="0" width="100%" height="200" fill="#e9ece9"></rect>
              <path d="M0 97L71.5 96.2C143 95.3 286 93.7 428.8 96C571.7 98.3 714.3 104.7 857.2 104.5C1000 104.3 1143 97.7 1285.8 93.5C1428.7 89.3 1571.3 87.7 1714.2 91.8C1857 96 2000 106 2142.8 107.5C2285.7 109 2428.3 102 2571.2 93.8C2714 85.7 2857 76.3 2928.5 71.7L3000 67L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#e9ece9"></path>
              <path d="M0 97L71.5 101.7C143 106.3 286 115.7 428.8 117.8C571.7 120 714.3 115 857.2 116C1000 117 1143 124 1285.8 121.3C1428.7 118.7 1571.3 106.3 1714.2 104C1857 101.7 2000 109.3 2142.8 116.3C2285.7 123.3 2428.3 129.7 2571.2 126C2714 122.3 2857 108.7 2928.5 101.8L3000 95L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#eef0ee"></path>
              <path d="M0 120L71.5 125C143 130 286 140 428.8 140.2C571.7 140.3 714.3 130.7 857.2 126.3C1000 122 1143 123 1285.8 128.5C1428.7 134 1571.3 144 1714.2 147.5C1857 151 2000 148 2142.8 142.5C2285.7 137 2428.3 129 2571.2 125.5C2714 122 2857 123 2928.5 123.5L3000 124L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#f2f4f2"></path>
              <path d="M0 162L71.5 162C143 162 286 162 428.8 162C571.7 162 714.3 162 857.2 160.2C1000 158.3 1143 154.7 1285.8 153.5C1428.7 152.3 1571.3 153.7 1714.2 155C1857 156.3 2000 157.7 2142.8 158.8C2285.7 160 2428.3 161 2571.2 162.7C2714 164.3 2857 166.7 2928.5 167.8L3000 169L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#f7f8f7"></path></svg>

            {anchor('namingceremonies')}
            <Container sx={{ marginTop: '0px' }} maxWidth="lg">
              <Box fullWidth sx={{ paddingTop: '1px' }} />
              <Typography sx={{ marginTop: '10px', color: '#b2cdc1', fontFamily: 'CochocibScriptLatinPro' }} variant={!isSmall ? "h1" : "h3"}>Naming Ceremonies</Typography>
              <Grid container spacing={2} direction="row" style={{ marginTop: '5px', }}>
                <Grid item xs={12} md={8} >
                  <Item elevation={0} sx={{ backgroundColor: '#f7f8f7', textAlign: 'left', fontFamily: 'Garamond' }}>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Naming ceremonies are a wonderful alternative to a religious christening or other event for parents who want to mark the arrival of their child in to their family. A naming ceremony is an opportunity to formally announce your child (ren) to the world, they're given a name and welcoming them into your family. It's a special day to celebrate with family and friends.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Although most commonly naming ceremonies are held for new babies, naming ceremonies a wonderful way to celebrate children of any age. Perhaps a way of welcoming adopted children or celebrating a newly blended family.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      The beauty of a celebrant led ceremony is that you can design the day and your celebration exactly to your liking. You are not bound by any legal requirements or religious restrictions. Although you are free to include religious readings on music if you wish. The naming ceremony can take place anywhere; your garden, a hotel, a function room or a local place of sentiment. Anywhere you like!
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Here are a few ideas of what you might like to include or what you might expect from a typical naming ceremony.
                    </Typography>
                    <ul>
                      <li>Storytelling about you as parents, the child's arrival, how your family came to be</li>
                      <li>How and why the name was chosen</li>
                      <li>The child's character and personality</li>
                      <li>Outlining the roles and responsibilities of you as parents</li>
                      <li>Parents promises to the child</li>
                      <li>Grandparents/siblings promises</li>
                      <li>Formal appointment of guardians / mentors (if you choose to have them)</li>
                      <li>Acknowledging wider family and their role in the child's life</li>
                      <li>Readings/Poems</li>
                      <li>Music</li>
                      <li>Ceremonial actions such as lighting candles, sand pouring</li>
                      <li>The naming itself</li>
                      <li>Presentation of the naming certificate or family gift</li>
                    </ul>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      To help you create a day truly unique feel naming ceremony, we can set up an initial video call to discuss preliminary plans. I will then send paperwork and questionnaires to help me build an idea for what you are looking for and the content you are hoping to include. I then can meet you at your home or the location of your naming ceremony on a day best suited for you so that we can chat through all your options and ideas before I write your full script. I will send you a first draft for your review to ensure all facts are correct and the flow of the writing is befitting your ceremony. I can schedule a video call to do a live reading if you prefer! I can then revise any edits you require. Prices include unlimited meetings with me as it's important we get everything right for your special day! I will then be present at your venue in good time before your ceremony and on hand for any support you need.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Prices from £300. Please do get in touch so that we can discuss your plans for your ceremony and make your celebration truly personal. Price of celebrant fees will vary dependent on your requirements.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Please note: a 50% non-refundable deposit will be payable at the time of booking to secure the date in my calendar and the remaining balance is due 28 days before your ceremony date.    </Typography>
                    <Box fullWidth sx={{ paddingTop: '20px' }} />
                  </Item>
                </Grid>
                <Grid item xs={12} md={4} >
                  <Item sx={{ backgroundColor: '#f7f8f7' }} elevation={0}>
                    <Typography sx={{ backgroundColor: '#f7f8f7', marginTop: '100px', color: 'Gray' }} variant="body"><img width="300px" sx={{ backgroundColor: '#f7f8f7', margin: 'auto', display: 'block' }} src={namingCeremonies} alt="Logo" /> </Typography>
                  </Item>
                </Grid>
              </Grid>
            </Container>

            <svg id="visual" viewBox="0 0 100% 200" width="100%" height="200" preserveAspectRatio="none" version="1.1"><rect x="0" y="0" width="100%" height="200" fill="#f7f8f7"></rect><path d="M0 97L71.5 96.2C143 95.3 286 93.7 428.8 96C571.7 98.3 714.3 104.7 857.2 104.5C1000 104.3 1143 97.7 1285.8 93.5C1428.7 89.3 1571.3 87.7 1714.2 91.8C1857 96 2000 106 2142.8 107.5C2285.7 109 2428.3 102 2571.2 93.8C2714 85.7 2857 76.3 2928.5 71.7L3000 67L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#f7f8f7"></path><path d="M0 97L71.5 101.7C143 106.3 286 115.7 428.8 117.8C571.7 120 714.3 115 857.2 116C1000 117 1143 124 1285.8 121.3C1428.7 118.7 1571.3 106.3 1714.2 104C1857 101.7 2000 109.3 2142.8 116.3C2285.7 123.3 2428.3 129.7 2571.2 126C2714 122.3 2857 108.7 2928.5 101.8L3000 95L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#f2f4f2"></path><path d="M0 120L71.5 125C143 130 286 140 428.8 140.2C571.7 140.3 714.3 130.7 857.2 126.3C1000 122 1143 123 1285.8 128.5C1428.7 134 1571.3 144 1714.2 147.5C1857 151 2000 148 2142.8 142.5C2285.7 137 2428.3 129 2571.2 125.5C2714 122 2857 123 2928.5 123.5L3000 124L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#eef0ee"></path><path d="M0 162L71.5 162C143 162 286 162 428.8 162C571.7 162 714.3 162 857.2 160.2C1000 158.3 1143 154.7 1285.8 153.5C1428.7 152.3 1571.3 153.7 1714.2 155C1857 156.3 2000 157.7 2142.8 158.8C2285.7 160 2428.3 161 2571.2 162.7C2714 164.3 2857 166.7 2928.5 167.8L3000 169L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#e9ece9"></path></svg>

          </Box>

          {/* Script Writing */}
          <Box sx={{ marginTop: '-10px', backgroundColor: '#e9ece9' }}>
            {anchor('scriptwriting')}
            <Container sx={{ marginTop: '0px' }} maxWidth="lg">
              <Box fullWidth sx={{ paddingTop: '1px' }} />
              <Typography sx={{ marginTop: '10px', color: '#b2cdc1', fontFamily: 'CochocibScriptLatinPro' }} variant={!isSmall ? "h1" : "h3"}>Script Writing Service</Typography>
              <Grid container spacing={2} direction="row" style={{ marginTop: '5px', }}>
                <Grid item xs={12} md={8} >
                  <Item elevation={0} sx={{ backgroundColor: '#e9ece9', textAlign: 'left', fontFamily: 'Garamond' }}>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Are you looking to have a ceremony but don’t necessarily want to use a celebrant on the day? You may want a member of your family or a friend to deliver the ceremony for you and make the day truly personal!
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      One of the biggest challenges is the writing process and creating a script and that’s where I can help you.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      We set up a meeting so I can sit with you and discuss what you have in mind for your ceremony and how we can bring your ideas to fruition. If you need any advice or support, I am on hand right up until the big day. I can take away that pressure of putting together a script and once complete its yours to keep and have delivered by the person of your choosing.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      If circumstances change, I can hold the date in my calendar should you wish me to step in at the last minute and be your Celebrant on the day.  </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Script writing services can be a great tool for you to use for ceremonies such as Funeral services, Memorial / Celebration of Life gatherings, Wedding ceremonies, Naming ceremonies as well as family celebrations.   </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Feel free to get in touch and we can discuss your ceremony and how I can support you in creating a memorable day.   </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Prices from £250. Please do get in touch so that we can discuss your plans for your ceremony and make your script truly personal. Price of celebrant fees will vary dependent on your requirements.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Are you looking to have a ceremony but don’t necessarily want to use a celebrant on the day? You may want a member of your family or a friend to deliver the ceremony for you and make the day truly personal!
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Please note: a 50% non-refundable deposit will be payable at the time of booking to secure the script writing service and the remaining balance is due on completion of the final draft.
                    </Typography>
                    <Box fullWidth sx={{ paddingTop: '20px' }} />
                  </Item>
                </Grid>
                <Grid item xs={12} md={4} >
                  <Item sx={{ backgroundColor: '#e9ece9' }} elevation={0}>
                    <Typography sx={{ backgroundColor: '#e9ece9', marginTop: '100px', color: 'Gray' }} variant="body"><img width="300px" sx={{ backgroundColor: '#e9ece9', margin: 'auto', display: 'block' }} src={scripts} alt="Logo" /> </Typography>
                  </Item>
                </Grid>
              </Grid>
            </Container>
          </Box>

          {/* Funerals */}
          <Box sx={{ backgroundColor: '#f7f8f7', fontFamily: 'Garamond', marginTop: '0px' }}>
            <svg id="visual" viewBox="0 0 100% 200" width="100%" height="200" preserveAspectRatio="none" version="1.1"><rect x="0" y="0" width="100%" height="200" fill="#e9ece9"></rect>
              <path d="M0 97L71.5 96.2C143 95.3 286 93.7 428.8 96C571.7 98.3 714.3 104.7 857.2 104.5C1000 104.3 1143 97.7 1285.8 93.5C1428.7 89.3 1571.3 87.7 1714.2 91.8C1857 96 2000 106 2142.8 107.5C2285.7 109 2428.3 102 2571.2 93.8C2714 85.7 2857 76.3 2928.5 71.7L3000 67L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#e9ece9"></path>
              <path d="M0 97L71.5 101.7C143 106.3 286 115.7 428.8 117.8C571.7 120 714.3 115 857.2 116C1000 117 1143 124 1285.8 121.3C1428.7 118.7 1571.3 106.3 1714.2 104C1857 101.7 2000 109.3 2142.8 116.3C2285.7 123.3 2428.3 129.7 2571.2 126C2714 122.3 2857 108.7 2928.5 101.8L3000 95L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#eef0ee"></path>
              <path d="M0 120L71.5 125C143 130 286 140 428.8 140.2C571.7 140.3 714.3 130.7 857.2 126.3C1000 122 1143 123 1285.8 128.5C1428.7 134 1571.3 144 1714.2 147.5C1857 151 2000 148 2142.8 142.5C2285.7 137 2428.3 129 2571.2 125.5C2714 122 2857 123 2928.5 123.5L3000 124L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#f2f4f2"></path>
              <path d="M0 162L71.5 162C143 162 286 162 428.8 162C571.7 162 714.3 162 857.2 160.2C1000 158.3 1143 154.7 1285.8 153.5C1428.7 152.3 1571.3 153.7 1714.2 155C1857 156.3 2000 157.7 2142.8 158.8C2285.7 160 2428.3 161 2571.2 162.7C2714 164.3 2857 166.7 2928.5 167.8L3000 169L3000 201L2928.5 201C2857 201 2714 201 2571.2 201C2428.3 201 2285.7 201 2142.8 201C2000 201 1857 201 1714.2 201C1571.3 201 1428.7 201 1285.8 201C1143 201 1000 201 857.2 201C714.3 201 571.7 201 428.8 201C286 201 143 201 71.5 201L0 201Z" fill="#f7f8f7"></path>
            </svg>
            {anchor('funerals')}
            <Container sx={{ marginTop: '0px' }} maxWidth="lg">
              <Box fullWidth sx={{ paddingTop: '1px' }} />
              <Typography sx={{ marginTop: '10px', color: '#b2cdc1', fontFamily: 'CochocibScriptLatinPro' }} variant={!isSmall ? "h1" : "h3"}>Funeral / Memorial Service</Typography>
              <Grid container spacing={2} direction="row" style={{ marginTop: '5px', }}>
                <Grid item xs={12} md={8} >
                  <Item elevation={0} sx={{ backgroundColor: '#f7f8f7', textAlign: 'left', fontFamily: 'Garamond' }}>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      My role as a Celebrant is to help you at every step of the way. Recently losing someone can be an overwhelming time and I hope I can provide you with support, ideas, experience and a safe place to grieve. As soon as we are in touch, I shall arrange a meeting with you to have a good chat and also have the privilege to learn about the life of your loved one then we can shape a service or celebration of their life. I come ready with guidance and can explain / take you through the day itself. My job is to make sure you say your final goodbyes remembering them just as they were. Together we can explore your options and it will give me the pleasure to learn all about your loved one. I will listen, support and encourage your decisions.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      We can discuss:
                      <ul>
                        <li>Music / Hymns</li>
                        <li>Readings / Poems</li>
                        <li>Eulogies / Family Tributes</li>
                      </ul>
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      I can also create ceremonies befitting cremations, burials, memorial services and scattering of ashes. It is your journey in grief and I am here to help you commemorate and celebrate their life. It is your chance to say goodbye as you see fit.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Prices from £230. Celebrant fees are payable via your Funeral Director and they will include in their final invoice. There is no charge for baby and child funerals.
                    </Typography>
                    <Box fullWidth sx={{ paddingTop: '20px' }} />
                  </Item>
                </Grid>
                <Grid item xs={12} md={4} >
                  <Item sx={{ backgroundColor: '#f7f8f7' }} elevation={0}>
                    <Typography sx={{ backgroundColor: '#f7f8f7', marginTop: '100px', color: 'Gray' }} variant="body">
                      {/* <ImageList
      sx={{ width: 500, height: 450 }}
      variant="quilted"
      cols={4}
      rowHeight={121}
    >
      {itemData.map((item) => (
        <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>
          <img
            {...srcset(item.img, 121, item.rows, item.cols)}
            alt={item.title}
            loading="lazy"
          />
        </ImageListItem>
      ))}
    </ImageList> */}
                      <img width="300px" sx={{ backgroundColor: '#f7f8f7', margin: 'auto', display: 'block' }} src={funerals} alt="Logo" /> </Typography>
                  </Item>
                </Grid>
              </Grid>
            </Container>
            <svg id="visual" viewBox="0 0 100% 200" width="100%" height="200" preserveAspectRatio="none" version="1.1"><rect x="0" y="0" width="100%" height="200" fill="#f7f8f7"></rect><path d="M0 36L45.5 42.5C91 49 182 62 272.8 73.3C363.7 84.7 454.3 94.3 545.2 87C636 79.7 727 55.3 818 63.7C909 72 1000 113 1091 127.7C1182 142.3 1273 130.7 1363.8 129.8C1454.7 129 1545.3 139 1636.2 136C1727 133 1818 117 1909 99.5C2000 82 2091 63 2182 57.2C2273 51.3 2364 58.7 2454.8 74C2545.7 89.3 2636.3 112.7 2727.2 108.8C2818 105 2909 74 2954.5 58.5L3000 43L3000 201L2954.5 201C2909 201 2818 201 2727.2 201C2636.3 201 2545.7 201 2454.8 201C2364 201 2273 201 2182 201C2091 201 2000 201 1909 201C1818 201 1727 201 1636.2 201C1545.3 201 1454.7 201 1363.8 201C1273 201 1182 201 1091 201C1000 201 909 201 818 201C727 201 636 201 545.2 201C454.3 201 363.7 201 272.8 201C182 201 91 201 45.5 201L0 201Z" fill="#f7f8f7"></path><path d="M0 67L45.5 66.7C91 66.3 182 65.7 272.8 71C363.7 76.3 454.3 87.7 545.2 99.5C636 111.3 727 123.7 818 122C909 120.3 1000 104.7 1091 101C1182 97.3 1273 105.7 1363.8 109.7C1454.7 113.7 1545.3 113.3 1636.2 118C1727 122.7 1818 132.3 1909 130.3C2000 128.3 2091 114.7 2182 112.3C2273 110 2364 119 2454.8 122C2545.7 125 2636.3 122 2727.2 121.3C2818 120.7 2909 122.3 2954.5 123.2L3000 124L3000 201L2954.5 201C2909 201 2818 201 2727.2 201C2636.3 201 2545.7 201 2454.8 201C2364 201 2273 201 2182 201C2091 201 2000 201 1909 201C1818 201 1727 201 1636.2 201C1545.3 201 1454.7 201 1363.8 201C1273 201 1182 201 1091 201C1000 201 909 201 818 201C727 201 636 201 545.2 201C454.3 201 363.7 201 272.8 201C182 201 91 201 45.5 201L0 201Z" fill="#eef0ee"></path><path d="M0 154L45.5 153.8C91 153.7 182 153.3 272.8 144C363.7 134.7 454.3 116.3 545.2 119.5C636 122.7 727 147.3 818 155.3C909 163.3 1000 154.7 1091 153C1182 151.3 1273 156.7 1363.8 160.8C1454.7 165 1545.3 168 1636.2 164.5C1727 161 1818 151 1909 140.2C2000 129.3 2091 117.7 2182 117.5C2273 117.3 2364 128.7 2454.8 130.7C2545.7 132.7 2636.3 125.3 2727.2 127C2818 128.7 2909 139.3 2954.5 144.7L3000 150L3000 201L2954.5 201C2909 201 2818 201 2727.2 201C2636.3 201 2545.7 201 2454.8 201C2364 201 2273 201 2182 201C2091 201 2000 201 1909 201C1818 201 1727 201 1636.2 201C1545.3 201 1454.7 201 1363.8 201C1273 201 1182 201 1091 201C1000 201 909 201 818 201C727 201 636 201 545.2 201C454.3 201 363.7 201 272.8 201C182 201 91 201 45.5 201L0 201Z" fill="#f4f5f4"></path><path d="M0 125L45.5 129.2C91 133.3 182 141.7 272.8 144.7C363.7 147.7 454.3 145.3 545.2 144.3C636 143.3 727 143.7 818 140.8C909 138 1000 132 1091 130.7C1182 129.3 1273 132.7 1363.8 138.8C1454.7 145 1545.3 154 1636.2 156C1727 158 1818 153 1909 155.3C2000 157.7 2091 167.3 2182 165.2C2273 163 2364 149 2454.8 146.2C2545.7 143.3 2636.3 151.7 2727.2 149.3C2818 147 2909 134 2954.5 127.5L3000 121L3000 201L2954.5 201C2909 201 2818 201 2727.2 201C2636.3 201 2545.7 201 2454.8 201C2364 201 2273 201 2182 201C2091 201 2000 201 1909 201C1818 201 1727 201 1636.2 201C1545.3 201 1454.7 201 1363.8 201C1273 201 1182 201 1091 201C1000 201 909 201 818 201C727 201 636 201 545.2 201C454.3 201 363.7 201 272.8 201C182 201 91 201 45.5 201L0 201Z" fill="#f9faf9"></path><path d="M0 170L45.5 169C91 168 182 166 272.8 168.3C363.7 170.7 454.3 177.3 545.2 176.5C636 175.7 727 167.3 818 165.2C909 163 1000 167 1091 164.5C1182 162 1273 153 1363.8 149.7C1454.7 146.3 1545.3 148.7 1636.2 151.3C1727 154 1818 157 1909 159.3C2000 161.7 2091 163.3 2182 162.5C2273 161.7 2364 158.3 2454.8 161.5C2545.7 164.7 2636.3 174.3 2727.2 179.5C2818 184.7 2909 185.3 2954.5 185.7L3000 186L3000 201L2954.5 201C2909 201 2818 201 2727.2 201C2636.3 201 2545.7 201 2454.8 201C2364 201 2273 201 2182 201C2091 201 2000 201 1909 201C1818 201 1727 201 1636.2 201C1545.3 201 1454.7 201 1363.8 201C1273 201 1182 201 1091 201C1000 201 909 201 818 201C727 201 636 201 545.2 201C454.3 201 363.7 201 272.8 201C182 201 91 201 45.5 201L0 201Z" fill="#ffffff"></path></svg>
          </Box>


          {/* Contact */}
          <Box sx={{ marginTop: '-10px', backgroundColor: 'white' }}>
            {anchor('contact')}
            <Container sx={{ marginTop: '0px' }} maxWidth="lg">
              <Box fullWidth sx={{ paddingTop: '1px' }} />
              <Typography sx={{ marginTop: '10px', color: '#b2cdc1', fontFamily: 'CochocibScriptLatinPro' }} variant={!isSmall ? "h1" : "h3"}>Contact</Typography>
              <Grid container spacing={6} style={{ marginTop: '5px' }}>
                <Grid item xs={12}>
                  <Typography sx={{ marginTop: '20px', color: 'Gray', fontFamily: 'Garamond' }} variant="body">Please reach out to me by any of the following methods:</Typography>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Item elevation={1} sx={{ fontFamily: 'Garamond', '&:hover': { backgroundColor: 'white' }, backgroundColor: '#f8fbfa', borderTop: '5px solid #b2cdc1', padding: '10px', height: '90px' }}>
                    <Tooltip title="Contact Number">
                      <IconButton color="primary" aria-label="07930472391" >
                        <a href="tel:07930472391" target="_blank" rel="noreferrer">
                          <LocalPhoneIcon sx={{ color: '#97bfb3', fontSize: '48px', display: 'block', float: 'left' }} />
                        </a>
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="07930472391">
                      <Typography sx={{ marginLeft: '10px', marginTop: '17px', color: 'Gray' }} variant="body">07930472391</Typography>
                    </Tooltip>
                  </Item>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Item elevation={1} sx={{ fontFamily: 'Garamond', '&:hover': { backgroundColor: 'white' }, backgroundColor: '#f8fbfa', borderTop: '5px solid #b2cdc1', padding: '10px', height: '90px' }}>
                    <Tooltip title="Email">
                      <IconButton color="primary" aria-label="emma@ebcelebrancy.com" >
                        <a href="mailto:emma@ebcelebrancy.com" target="_blank" rel="noreferrer">
                          <AlternateEmailIcon sx={{ color: 'Gray', fontSize: '48px' }} />
                        </a>
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="emma@ebcelebrancy.com">
                      <Typography sx={{ marginLeft: '10px', marginTop: '17px', color: 'Gray' }} variant="body">emma@ebcelebrancy.com</Typography>
                    </Tooltip>
                  </Item>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Item elevation={1} sx={{ '&:hover': { backgroundColor: 'white' }, backgroundColor: '#f8fbfa', borderTop: '5px solid #b2cdc1', padding: '10px' }}>
                    <Tooltip title="Instagram">
                      <IconButton sx={{ paddingLeft: 'px' }} color="primary" aria-label="Instagram" >
                        <a href="https://www.instagram.com/emmabutlercelebrant" target="_blank" rel="noreferrer">
                          <img align="left" width="50px" src={socialsInstagram} alt="My Instagram profile" />
                        </a>
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Facebook">
                      <IconButton color="primary" aria-label="Facebook" >
                        <a href="https://www.facebook.com/Emma-Butler-Independent-Celebrant-115173494526218" target="_blank" rel="noreferrer">
                          <img align="left" width="50px" src={socialsFacebook} alt="My Facebook profile" />
                        </a>
                      </IconButton>
                    </Tooltip>
                  </Item>
                </Grid>
                <Grid item xs={12}>
                  <Divider sx={{ fontFamily: 'Garamond', color: '#b2cdc1', fontSize: '16px', marginBottom: '20px' }}>OR</Divider>
                  <form onSubmit={submit} method="post">
                    {email()}
                    <TextField sx={{ marginTop: '20px' }} required fullWidth id="standard-basic" label="Name" name="name" variant="outlined" />
                    <TextField sx={{ marginTop: '20px' }} required fullWidth id="standard-basic" label="Contact Number" name="contactnumber" variant="outlined" />
                    <TextField sx={{ marginTop: '20px' }} type="email" required fullWidth id="standard-basic" label="Email Address" name="email" variant="outlined" />
                    <TextField sx={{ marginTop: '20px' }} required multiline rows={4} fullWidth id="standard-basic" label="Short Message" name="message" variant="outlined" />
                    <Button type="submit" disabled={emailSentSuccessfully} sx={{ marginTop: '20px' }} fullWidth variant="contained" color="secondary">Send</Button>
                  </form>

                </Grid>
              </Grid>
            </Container>
          </Box>

          {/* Instagram feed */}
          <Box sx={{ marginTop: '40px', backgroundColor: 'white' }}>
            {anchor('feed')}
            <Container sx={{ marginTop: '0px' }} maxWidth="lg">
              <Box fullWidth sx={{ paddingTop: '1px' }} >

                <div className="elfsight-app-3eed583e-2756-4a05-9ce6-3a564db76343"></div>
              </Box>
            </Container>
          </Box>

          {/* Privacy & Cookies */}
          <Box sx={{ marginTop: '40px', backgroundColor: 'white' }}>
            {anchor('scriptwriting')}
            <Container sx={{ marginTop: '0px' }} maxWidth="lg">
              <Box fullWidth sx={{ paddingTop: '1px' }} />
              <Typography sx={{ marginTop: '10px', color: '#b2cdc1', fontFamily: 'CochocibScriptLatinPro' }} variant={!isSmall ? "h1" : "h3"}>Privacy & Cookies</Typography>
              <Grid container spacing={2} direction="row" style={{ marginTop: '5px', }}>
                <Grid item xs={12}>
                  <Item elevation={0} sx={{ backgroundColor: 'white', textAlign: 'left', fontFamily: 'Garamond' }}>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      I am Emma Butler and I trade as “Emma Butler Independent Celebrant” and “EBCelebrancy”.
                      I may be contacted via email at emma@ebcelebrancy.com or by post: Poplar House Stoke Road, Bishops Cleeve, Cheltenham, Gloucestershire, GL52 7RT
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">

                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      I may process “personal data” and/or “special category data” as defined in UK data protection legislation.
                      This processing may be on my own behalf or on behalf of my clients – either way I process data as part of the contracted services and/or my administration.
                      I realise the importance of confidentiality.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Data may be processed on paper and/or in electronic formats. When processed electronically, data may be held on a cloud-based system and/or on a local server.
                      Regardless of how data are processed, all feasible security measures are in place. Data is held as long as they are relevant to the purpose for collection and/or if there is a statutory retention period.
                      All data is destroyed by secure means when no longer required.
                      Data may be shared with third parties as part of my contracted services and/or if I am required by law to do so. I cannot accept any liability for any processing conducted by a third party outside my remit.
                    </Typography>

                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      As part of my compliance, I have conducted a cookie audit on my website.
                      Cookies are internet files used by the system to view websites and their content. I utilise analytical cookies to help me monitor and develop the site.
                      You are at liberty to turn off cookies through your browser but you should be aware that this may affect your viewing experience.
                      None of the above affects your rights under the legislation, in particular your right to access the data we hold on you. If you wish to request a copy of your data, please submit it in writing/email to me.
                      Please include enough information to enable me to identify you and search for appropriate data.
                      If you are dissatisfied with this policy, have queries about my data protection procedures or wish to lodge a complaint, please contact the business in the first instance.
                    </Typography>

                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Thereafter you have the right to submit a complaint to the Supervisory Authority, the Information Commissioner’s Office (ICO):<br />
                      The Information Commissioner’s Office<br />
                      Wycliffe House<br />
                      Water Lane<br />
                      Wilmslow<br />
                      Cheshire SK9 5AF
                    </Typography>


                    <Box fullWidth sx={{ paddingTop: '20px' }} />
                  </Item>
                </Grid>
              </Grid>
            </Container>
          </Box>

          {/* Copyright */}
          <Box sx={{ marginTop: '40px', backgroundColor: 'white' }}>
            {anchor('scriptwriting')}
            <Container sx={{ marginTop: '0px' }} maxWidth="lg">
              <Box fullWidth sx={{ paddingTop: '1px' }} />
              <Typography sx={{ marginTop: '10px', color: '#b2cdc1', fontFamily: 'CochocibScriptLatinPro' }} variant={!isSmall ? "h1" : "h3"}>Copyright</Typography>
              <Grid container spacing={2} direction="row" style={{ marginTop: '5px', }}>
                <Grid item xs={12}>
                  <Item elevation={0} sx={{ backgroundColor: 'white', textAlign: 'left', fontFamily: 'Garamond' }}>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      This website and its content, including blog, is copyright of Emma Butler Independent Celebrant – © Emma Butler Independent Celebrant 2023.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      All rights reserved.
                    </Typography>
                    <Typography sx={{ marginTop: '20px', color: 'Gray', display: 'block' }} variant="body">
                      Any redistribution or reproduction of part or all of the contents in any form is prohibited other than the following:
                      <ul>
                        <li>You may print or download to a local hard disk extracts for your personal and non-commercial use only.</li>
                        <li>You may copy the content to individual third parties for their personal use, but only if you acknowledge the website as the source of the material.</li>
                        <li>You may not, except with our express written permission, distribute or commercially exploit the content. Nor may you transmit it or store it in any other website or other form of electronic retrieval system. </li>
                      </ul>
                    </Typography>
                    <Box fullWidth sx={{ paddingTop: '20px' }} />
                  </Item>
                </Grid>
              </Grid>
            </Container>
          </Box>


          {/* Footer */}
          <Box id="footer" sx={{ marginTop: '0px', width: 1, height: 200, backgroundColor: 'white' }}>
            <svg id="visual" viewBox="0 0 100% 200" width="100%" height="200" preserveAspectRatio="none" version="1.1"><rect x="0" y="0" width="100%" height="200" fill="#fff"></rect><path d="M0 149L21.7 141C43.3 133 86.7 117 130.2 108C173.7 99 217.3 97 260.8 101C304.3 105 347.7 115 391.2 118.7C434.7 122.3 478.3 119.7 521.8 119C565.3 118.3 608.7 119.7 652.2 124.3C695.7 129 739.3 137 782.8 139C826.3 141 869.7 137 913 127C956.3 117 999.7 101 1043.2 97.5C1086.7 94 1130.3 103 1173.8 109.8C1217.3 116.7 1260.7 121.3 1304.2 124.7C1347.7 128 1391.3 130 1434.8 131.3C1478.3 132.7 1521.7 133.3 1565.2 130.3C1608.7 127.3 1652.3 120.7 1695.8 114.8C1739.3 109 1782.7 104 1826.2 108.8C1869.7 113.7 1913.3 128.3 1956.8 126.7C2000.3 125 2043.7 107 2087 106.8C2130.3 106.7 2173.7 124.3 2217.2 127.7C2260.7 131 2304.3 120 2347.8 120C2391.3 120 2434.7 131 2478.2 136.5C2521.7 142 2565.3 142 2608.8 138.3C2652.3 134.7 2695.7 127.3 2739.2 126.5C2782.7 125.7 2826.3 131.3 2869.8 134.8C2913.3 138.3 2956.7 139.7 2978.3 140.3L3000 141L3000 201L2978.3 201C2956.7 201 2913.3 201 2869.8 201C2826.3 201 2782.7 201 2739.2 201C2695.7 201 2652.3 201 2608.8 201C2565.3 201 2521.7 201 2478.2 201C2434.7 201 2391.3 201 2347.8 201C2304.3 201 2260.7 201 2217.2 201C2173.7 201 2130.3 201 2087 201C2043.7 201 2000.3 201 1956.8 201C1913.3 201 1869.7 201 1826.2 201C1782.7 201 1739.3 201 1695.8 201C1652.3 201 1608.7 201 1565.2 201C1521.7 201 1478.3 201 1434.8 201C1391.3 201 1347.7 201 1304.2 201C1260.7 201 1217.3 201 1173.8 201C1130.3 201 1086.7 201 1043.2 201C999.7 201 956.3 201 913 201C869.7 201 826.3 201 782.8 201C739.3 201 695.7 201 652.2 201C608.7 201 565.3 201 521.8 201C478.3 201 434.7 201 391.2 201C347.7 201 304.3 201 260.8 201C217.3 201 173.7 201 130.2 201C86.7 201 43.3 201 21.7 201L0 201Z" fill="#e4ebe7"></path><path d="M0 150L21.7 149.7C43.3 149.3 86.7 148.7 130.2 144.3C173.7 140 217.3 132 260.8 130C304.3 128 347.7 132 391.2 137.2C434.7 142.3 478.3 148.7 521.8 147.8C565.3 147 608.7 139 652.2 134.2C695.7 129.3 739.3 127.7 782.8 125.5C826.3 123.3 869.7 120.7 913 124.5C956.3 128.3 999.7 138.7 1043.2 137.8C1086.7 137 1130.3 125 1173.8 125.8C1217.3 126.7 1260.7 140.3 1304.2 148.3C1347.7 156.3 1391.3 158.7 1434.8 153.8C1478.3 149 1521.7 137 1565.2 137.2C1608.7 137.3 1652.3 149.7 1695.8 150.7C1739.3 151.7 1782.7 141.3 1826.2 136.8C1869.7 132.3 1913.3 133.7 1956.8 137.7C2000.3 141.7 2043.7 148.3 2087 151.5C2130.3 154.7 2173.7 154.3 2217.2 151.2C2260.7 148 2304.3 142 2347.8 140.3C2391.3 138.7 2434.7 141.3 2478.2 142.7C2521.7 144 2565.3 144 2608.8 141.5C2652.3 139 2695.7 134 2739.2 134.8C2782.7 135.7 2826.3 142.3 2869.8 146.5C2913.3 150.7 2956.7 152.3 2978.3 153.2L3000 154L3000 201L2978.3 201C2956.7 201 2913.3 201 2869.8 201C2826.3 201 2782.7 201 2739.2 201C2695.7 201 2652.3 201 2608.8 201C2565.3 201 2521.7 201 2478.2 201C2434.7 201 2391.3 201 2347.8 201C2304.3 201 2260.7 201 2217.2 201C2173.7 201 2130.3 201 2087 201C2043.7 201 2000.3 201 1956.8 201C1913.3 201 1869.7 201 1826.2 201C1782.7 201 1739.3 201 1695.8 201C1652.3 201 1608.7 201 1565.2 201C1521.7 201 1478.3 201 1434.8 201C1391.3 201 1347.7 201 1304.2 201C1260.7 201 1217.3 201 1173.8 201C1130.3 201 1086.7 201 1043.2 201C999.7 201 956.3 201 913 201C869.7 201 826.3 201 782.8 201C739.3 201 695.7 201 652.2 201C608.7 201 565.3 201 521.8 201C478.3 201 434.7 201 391.2 201C347.7 201 304.3 201 260.8 201C217.3 201 173.7 201 130.2 201C86.7 201 43.3 201 21.7 201L0 201Z" fill="#cbdcd3"></path><path d="M0 152L21.7 150.3C43.3 148.7 86.7 145.3 130.2 144.7C173.7 144 217.3 146 260.8 147.7C304.3 149.3 347.7 150.7 391.2 154C434.7 157.3 478.3 162.7 521.8 166C565.3 169.3 608.7 170.7 652.2 168.7C695.7 166.7 739.3 161.3 782.8 159.8C826.3 158.3 869.7 160.7 913 162.5C956.3 164.3 999.7 165.7 1043.2 165.7C1086.7 165.7 1130.3 164.3 1173.8 161C1217.3 157.7 1260.7 152.3 1304.2 154C1347.7 155.7 1391.3 164.3 1434.8 167.7C1478.3 171 1521.7 169 1565.2 167.7C1608.7 166.3 1652.3 165.7 1695.8 166C1739.3 166.3 1782.7 167.7 1826.2 169C1869.7 170.3 1913.3 171.7 1956.8 168.3C2000.3 165 2043.7 157 2087 154.2C2130.3 151.3 2173.7 153.7 2217.2 157.3C2260.7 161 2304.3 166 2347.8 168.7C2391.3 171.3 2434.7 171.7 2478.2 169.7C2521.7 167.7 2565.3 163.3 2608.8 159.5C2652.3 155.7 2695.7 152.3 2739.2 155C2782.7 157.7 2826.3 166.3 2869.8 168.8C2913.3 171.3 2956.7 167.7 2978.3 165.8L3000 164L3000 201L2978.3 201C2956.7 201 2913.3 201 2869.8 201C2826.3 201 2782.7 201 2739.2 201C2695.7 201 2652.3 201 2608.8 201C2565.3 201 2521.7 201 2478.2 201C2434.7 201 2391.3 201 2347.8 201C2304.3 201 2260.7 201 2217.2 201C2173.7 201 2130.3 201 2087 201C2043.7 201 2000.3 201 1956.8 201C1913.3 201 1869.7 201 1826.2 201C1782.7 201 1739.3 201 1695.8 201C1652.3 201 1608.7 201 1565.2 201C1521.7 201 1478.3 201 1434.8 201C1391.3 201 1347.7 201 1304.2 201C1260.7 201 1217.3 201 1173.8 201C1130.3 201 1086.7 201 1043.2 201C999.7 201 956.3 201 913 201C869.7 201 826.3 201 782.8 201C739.3 201 695.7 201 652.2 201C608.7 201 565.3 201 521.8 201C478.3 201 434.7 201 391.2 201C347.7 201 304.3 201 260.8 201C217.3 201 173.7 201 130.2 201C86.7 201 43.3 201 21.7 201L0 201Z" fill="#b2cdc1"></path></svg>

            <Box id="footer" sx={{ width: 1, height: 200, backgroundColor: '#b2cdc1' }}>
              <Container sx={{ marginTop: '0px' }} maxWidth="lg">
                <Grid container alignItems="center" spacing={2} direction="column">
                  <Grid style={{ marginTop: '0px' }} item lg={12}>
                    <Box sx={{ marginTop: '50px', display: 'inline' }}>
                      <Tooltip title="Instagram">
                        <IconButton sx={{ display: 'inline', float: 'left' }} color="primary" aria-label="Instagram" >
                          <a sx={{ display: 'block', float: 'left' }} href="https://www.instagram.com/emmabutlercelebrant" target="_blank" rel="noreferrer">
                            <img align="left" width="50px" src={socialsInstagramWhite} alt="My Instagram profile" />
                          </a>
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box sx={{ width: '200px', marginTop: '50px', display: 'inline' }}>
                      <Tooltip title="Facebook">
                        <IconButton sx={{ display: 'inline', float: 'left' }} color="primary" aria-label="Facebook" >
                          <a sx={{ display: 'block', float: 'left' }} href="https://www.facebook.com/Emma-Butler-Independent-Celebrant-115173494526218" target="_blank" rel="noreferrer">
                            <img align="left" width="50px" src={socialsFacebookWhite} alt="My Facebook profile" />
                          </a>
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Box sx={{ width: '200px', marginTop: '50px', display: 'inline' }}>
                      <Tooltip title="Fellowship of Professional Celebrants">
                        <IconButton sx={{ display: 'inline', float: 'left' }} color="primary" aria-label="Fellowship of Professional Celebrants" >
                          <a sx={{ display: 'block', float: 'left' }} href="https://professionalcelebrants.org.uk/" target="_blank" rel="noreferrer">
                            <img align="left" width="50px" src={fpcWhite} alt="Fellowship of Professional Celebrants" />
                          </a>
                        </IconButton>
                      </Tooltip>
                    </Box>
                    

                  </Grid>
                  <Grid item lg={12}>
                    <Typography sx={{ fontFamily: 'Garamond', display: 'block', float: 'left', marginLeft: '10px', marginTop: '0px', color: '#ededed' }} variant="body">© 2023 Emma Butler</Typography>
                  </Grid>
                </Grid>
              </Container>
            </Box>
          </Box>
        </Paper>
      </ThemeProvider>
    </>
  );
}

export default App;